require('./index.sass');
require('./component-spinner-button');

module.exports = 'component-spinner-button';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/component-spinner-button/index.js
 ** module id = 80
 ** module chunks = 1
 **/